
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artists/[id]/[[...slug]]",
      function () {
        return require("private-next-pages/artists/[id]/[[...slug]].tsx");
      }
    ]);
  